import React, { useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Brand from '../Brand/Brand';
import Navigation, { NavigationLine } from '../Navigation/Navigation';
import {
	componentsMenu,
	dashboardMenu,
	demoPages,
	layoutMenu,
	settingsMenu,
	userMenu,
	boardMenu
} from '../../menu';
import ThemeContext from '../../contexts/themeContext';
import Card, { CardBody } from '../../components/bootstrap/Card';

import Hand from '../../assets/img/hand.png';
import HandWebp from '../../assets/img/hand.webp';
import Icon from '../../components/icon/Icon';
import Button from '../../components/bootstrap/Button';
import Tooltips from '../../components/bootstrap/Tooltips';
import useDarkMode from '../../hooks/useDarkMode';
import useAsideTouch from '../../hooks/useAsideTouch';
import OffCanvas, {
	OffCanvasBody,
	OffCanvasHeader,
	OffCanvasTitle,
} from '../../components/bootstrap/OffCanvas';
import Alert, { AlertHeading, AlertLink } from '../../components/bootstrap/Alert';
import { useMst } from '../../models';
import { useEffectOnce } from 'react-use';
import { observer } from 'mobx-react';
import { removeItem } from '../../lib/localstorage';

let tmpdashboardMenu = {}
const Aside = observer( () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	const { asideStyle, touchStatus, hasTouchButton, asideWidthWithSpace, x } = useAsideTouch();

	const isModernDesign = process.env.REACT_APP_MODERN_DESGIN === 'true';

	const constraintsRef = useRef(null);

	// const [doc, setDoc] = useState(false);

	const { t } = useTranslation(['translation', 'menu']);

	const { darkModeStatus } = useDarkMode();

	const [isNotiOffCanvasOpen, setIsNotiOffCanvasOpen] = useState(false);

	const { user } = useMst();

	// useEffectOnce(() => {
	// 	권한에 따른 메뉴 동적생성
	// 	console.log('dashboardMenu ===================> ', dashboardMenu);
	// 	dashboardMenu.authManagement.text = 'SRM 권한 관리';
	// 	delete dashboardMenu.authManagement.subMenu.authMenuManagement;
	// 	delete dashboardMenu.authManagement.subMenu.authUserManagement;
	// });
	//const 권한 = '어드민';

	useEffect(() => {
		
		tmpdashboardMenu = {...dashboardMenu}
		if(user?.me?.userType !== "SUPER_ADMIN") {

			delete tmpdashboardMenu.interfaceLog;
			delete tmpdashboardMenu.coSysManagement;
			// delete dashboardMenu.auth.subMenu.authCCP
			
			switch(user?.me?.isAdmin) {
				case true:
					// delete dashboardMenu.user.subMenu.authCCP
					break;
				case false:
					delete tmpdashboardMenu.user.subMenu[2]
					delete tmpdashboardMenu.user.subMenu[0]
					delete tmpdashboardMenu.SAPVendorManagement;
					delete tmpdashboardMenu.connentionSystem;
					break;
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user?.me?.userType])

	useEffectOnce(()=>{

		
	})

	return (
		<>
			<motion.aside
				style={asideStyle}
				className={classNames(
					'aside',
					{ open: asideStatus },
					{
						'aside-touch-bar': hasTouchButton && isModernDesign,
						'aside-touch-bar-close': !touchStatus && hasTouchButton && isModernDesign,
						'aside-touch-bar-open': touchStatus && hasTouchButton && isModernDesign,
					},
				)}>
				<div className='aside-head'>
					<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />					
				</div>
				<div className='aside-body'>


					{/* {권한 === '어드민' && <Navigation menu={dashboardMenu} id='aside-dashboard' />} */}
					<Navigation menu={tmpdashboardMenu} id='aside-dashboard' />

					{/* <NavigationLine />
					<Navigation menu={settingsMenu} id='aside-settings' /> */}
					{/* <NavigationLine />
					<div className='navigation'>
						<div
							id="notification"
							className='navigation-item cursor-pointer'
							onClick={() => {
								setIsNotiOffCanvasOpen(true);
							}}>
							<span className='navigation-link navigation-link-pill'>
								<span className='navigation-link-info'>
                 					 <i className="ri-notification-2-line navigation-icon"></i>
									<span className='navigation-text'>{`알림`}</span>
								</span>
							</span>
						</div>
					</div> */}
					{/* <Navigation menu={userMenu} id='aside-userpage' /> */}

					{/* {!doc && (
						<>
							<NavigationLine />
							<Navigation menu={demoPages} id='aside-demo-pages' />
							<NavigationLine />
							<Navigation menu={layoutMenu} id='aside-menu' />
						</>
					)}

					{doc && (
						<>
							<NavigationLine />
							<Navigation menu={componentsMenu} id='aside-menu-two' />
							<NavigationLine />
						</>
					)} */}

					{/* {asideStatus && doc && (
						<Card className='m-3 '>
							<CardBody className='pt-0'>
								<img
									srcSet={HandWebp}
									src={Hand}
									alt='Hand'
									width={130}
									height={130}
								/>
								<p
									className={classNames('h4', {
										'text-dark': !darkModeStatus,
										'text-light': darkModeStatus,
									})}>
									{t('Everything is ready!')}
								</p>
								<Button
									color='info'
									isLight
									className='w-100'
									onClick={() => setDoc(false)}>
									{t('Demo Pages')}
								</Button>
							</CardBody>
						</Card>
					)} */}
				</div>
				<div className='aside-foot'>  
          <ol className='navigation navi-logout'>
            {/* <li className='navigation-item'
                onClick={() => window.open(`http://ccp.kemcluster.com/`, "_blank")}
              >
                <div aria-current='page' className='navigation-link navigation-link-pill'>
                  <span className='navigation-link-info'>
                    <i className="ri-external-link-fill me-2"></i>
                    <span className='navigation-text'>사용자 바로가기</span>
                  </span>
                </div>
              </li> */}
							<li className='navigation-item'
                onClick={async () => {
                  removeItem('access-token')
                  removeItem('user-idx')
                  removeItem('refresh-token')
                  removeItem('rootState')
                  location.href = window.location.host.indexOf('localhost') > -1 ? '/' : '/exsignon/sso/logout';
                }}
              >
									<div aria-current='page' className='navigation-link navigation-link-pill'>
										<span className='navigation-link-info'>
                      <i className="ri-logout-box-r-line me-2"></i>
											<span className='navigation-text'>로그아웃</span>
										</span>
									</div>

							</li>
						</ol>        
					{/* <nav aria-label='aside-bottom-menu'>
						<div className='navigation'>
							<div
								role='presentation'
								className='navigation-item cursor-pointer'
								onClick={() => {
									setDoc(!doc);
								}}
								data-tour='documentation'>
								<span className='navigation-link navigation-link-pill'>
									<span className='navigation-link-info'>
										<Icon
											icon={doc ? 'ToggleOn' : 'ToggleOff'}
											color={doc ? 'success' : null}
											className='navigation-icon'
										/>
										<span className='navigation-text'>
											{t('menu:Documentation')}
										</span>
									</span>
								</span>
							</div>
						</div>
					</nav> */}
				</div>
			</motion.aside>
			{asideStatus && hasTouchButton && isModernDesign && (
				<>
					<motion.div className='aside-drag-area' ref={constraintsRef} />
					<Tooltips title='Toggle Aside' flip={['top', 'right']}>
						<motion.div
							className='aside-touch'
							drag='x'
							whileDrag={{ scale: 1.2 }}
							whileHover={{ scale: 1.1 }}
							dragConstraints={constraintsRef}
							// onDrag={(event, info) => console.log(info.point.x, info.point.y)}
							dragElastic={0.1}
							style={{ x, zIndex: 1039 }}
							onClick={() => x.set(x.get() === 0 ? asideWidthWithSpace : 0)}
						/>
					</Tooltips>
				</>
			)}

			<OffCanvas isOpen={isNotiOffCanvasOpen} setOpen={setIsNotiOffCanvasOpen}>
				<OffCanvasHeader setOpen={setIsNotiOffCanvasOpen}>
					<OffCanvasTitle id={'notiTitle'}>알림</OffCanvasTitle>
				</OffCanvasHeader>
				<OffCanvasBody>
					<div className='d-flex h-50 justify-content-center align-items-center'>알림 내역이 없습니다.</div>
					{/* <Alert color={'primary'} shadow={'sm'} icon={'AcUnit'} isOutline>
						<AlertLink className={'text-decoration-none'} to={'/'}>
							<AlertHeading>알림 제목</AlertHeading>
							알림 내용
						</AlertLink>
					</Alert>
					<Alert color={'info'} shadow={'sm'} icon={'AccountBalance'} isOutline>
						<AlertLink className={'text-decoration-none'} to={'/user/management'}>
							<AlertHeading>알림1 제목</AlertHeading>
							알림1 내용
						</AlertLink>
					</Alert> */}
				</OffCanvasBody>
			</OffCanvas>
		</>
	);
});

export default Aside;
